
import React from 'react'
import { BsEyeFill } from "react-icons/bs";
import { Link } from 'react-router-dom';

function StarCardSchedule({ title, icon, link }) {
     return (
          <>
               <div className="col-md-3 mb-3">
                    <div className="card bg-black border-warning">

                         <div className="pt-3 d-flex justify-content-center align-items-center text-warning">
                              {icon}
                         </div>

                         <div className="pt-2 d-flex justify-content-center align-items-center text-light">
                              <h5>{title}</h5>
                         </div>

                         <Link to={{ pathname: link, state: { title } }}className="Link w-100">
                              <button className="btn card-schedule-btn text-light fw-bold mt-2 w-100"> <BsEyeFill/></button>
                         </Link>
                         
                    </div>
               </div>
          </>
     )
}

export default StarCardSchedule
